// export const DOMAIN = "http://localhost:4000"; 
// export const DOMAIN = "https://api.elephant.fr.zvshsuddhdndnmxmx4.fun"; //4
// export const DOMAIN = "https://api.elephant.bro.zvshsuddhdndnmxmx4.fun"; //3y
export const DOMAIN = "https://n.alamonianca1.life"; //2
// export const DOMAIN = "https://api.elephant.zvshsuddhdndnmxmx4.fun"; //1
// export const DOMAIN = "https://api.elephant.boss.zvshsuddhdndnmxmx4.fun"; //0


export const DOMAIN_FB = `${DOMAIN}/api/fb/`;

// export const DOMAIN_FORM = `redirect-form.shanecrista7.workers.dev`; //2
export const DOMAIN_FORM = `redirect-form.taylorchristophergqzor5579.workers.dev`; //1


